import Table from "react-bootstrap/Table";

import { DiagnosticHypothesisGroupByProfessional } from "@/@types/sintegrada/sintegradaServerApi/DiagnosticHypothesisGroupByProfessional";

import { TableSkeletons } from "@/components/TableSkeletons";

type Props = {
	isLoading?: boolean;
	results: DiagnosticHypothesisGroupByProfessional[];
};

export function DiagnosticHypothesisGroupByProfessionalTable({ isLoading, results }: Props) {
	const hasData = Boolean(results?.length);

	return (
		<Table>
			<thead>
				<tr className="fw-bold">
					<th>Profissional</th>
					<th>CID</th>
					<th>Total</th>
				</tr>
			</thead>

			<tbody>
				{isLoading ? (
					<TableSkeletons numberOfCells={3} numberOfRows={15} />
				) : hasData ? (
					results.map((result, index) => (
						<tr key={`diagnostic-hypothesis-${index}`}>
							<td>{result.professional_name || "N/A"}</td>
							<td>{result.icd_description || "N/A"}</td>
							<td>{result.total || 0}</td>
						</tr>
					))
				) : (
					<tr>
						<td colSpan={12} className="text-center text-black-50 fw-bold">
							Nenhum resultado encontrado
						</td>
					</tr>
				)}
			</tbody>
		</Table>
	);
}
